import useApiQuery from '@hooks/useApiQuery';
import QueryKeys from '@src/constants/queryKeys';
import { WidgetConfigBase } from '@src/types/Widget';

export interface WidgetSearchFilter {
  name?: { $regex: string; $options?: string } | string;
  type?: string;
  internalId?: { $regex: string; $options?: string } | string;
  isSystemWidget?: boolean;
  deleted?: boolean;
  [key: string]:
    | { $regex: string; $options?: string }
    | string
    | number
    | boolean
    | null
    | undefined;
}

export interface UseSearchWidgetConfigsProps {
  filter: WidgetSearchFilter;
  enabled?: boolean;
}

export default ({ filter, enabled = true }: UseSearchWidgetConfigsProps) =>
  useApiQuery<WidgetConfigBase[]>({
    queryKey: [QueryKeys.widgets, 'search', JSON.stringify(filter)],
    apiPath: '/widgets/search',
    method: 'POST',
    body: { filter },
    useV2API: true,
    enabled,
  });
